'use client';

import { c as _c } from "react/compiler-runtime";
import { captureException } from '@sentry/nextjs';
import { useEffect, useRef } from 'react';
import { AuthApi } from '@/api';
import { COOKIE_OPTIONS, COOKIES_KEYS } from '@/constants';
import { useAccessToken } from '@/hooks/useAccessToken';
import { cookies } from '@/utils/cookies';

//* 도착 시 이미 로그인이면 마운트가, 로그인 직후면 토큰 생성이 이 effect를 깨운다 — BE는 멱등이라 페이지당 1회만 부른다
export const PartnersAttributionController = () => {
  const $ = _c(4);
  const {
    accessToken
  } = useAccessToken();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = new Set();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const attributedClickTokensRef = useRef(t0);
  let t1;
  let t2;
  if ($[1] !== accessToken) {
    t1 = () => {
      if (!accessToken) {
        attributedClickTokensRef.current.clear();
        return;
      }
      const clickToken = cookies.get(COOKIES_KEYS.PARTNERS_CLICK_TOKEN);
      if (!clickToken || attributedClickTokensRef.current.has(clickToken)) {
        return;
      }
      attributedClickTokensRef.current.add(clickToken);
      AuthApi["post:/wello/v2/auth/short-link-attributions"]({
        body: {
          clickToken
        }
      }).then(_temp).catch(captureException);
    };
    t2 = [accessToken];
    $[1] = accessToken;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return null;
};
function _temp() {
  return cookies.remove(COOKIES_KEYS.PARTNERS_CLICK_TOKEN, COOKIE_OPTIONS);
}